export const FETCH_GOOGLE_REQUEST = "FETCH_GOOGLE_REQUEST";
export const FETCH_GOOGLE_SUCCESS = "FETCH_GOOGLE_SUCCESS";
export const FETCH_GOOGLE_FAIL = "FETCH_GOOGLE_FAIL";
export const FETCH_GOOGLE_LOGOUT = "FETCH_GOOGLE_LOGOUT";

export const fetchGoogleRequest = () => {
  return {
    type: FETCH_GOOGLE_REQUEST,
  };
};
export const fetchGoogleSuccess = (data) => {
  return {
    type: FETCH_GOOGLE_SUCCESS,
    data,
  };
};
export const fetchGoogleFail = (error) => {
  return {
    type: FETCH_GOOGLE_FAIL,
    error,
  };
};

export const fetchGoogleLogout = () => {
  return {
    type: FETCH_GOOGLE_LOGOUT,
  };
};

export const googleLoginSuccess =
  (tokenResponse) => async (dispatch, getState) => {
    console.log("TEST!");
    dispatch(fetchGoogleSuccess(tokenResponse));
  };

export const googleLoginFail = (error) => async (dispatch, getState) => {
  dispatch(fetchGoogleFail(error));
};

export const googleLogout = () => async (dispatch, getState) => {
  console.log("GoogleLogout!");
  dispatch(fetchGoogleLogout());
};

// export const getGoogleUserThunk = () => async (dispatch, getState) => {
//     try {
//       dispatch(fetchGoogleRequest());
//       const res = await axios.get("https://api.github.com/users");
//       dispatch(getUsersSuccess(res.data));
//     } catch (error) {
//       dispatch(getUsersFail(error));
//     }
//   };
